var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, htmlAttributes = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 10.06 13.89", className: className }, htmlAttributes),
        React.createElement("path", { d: "M13.89,8.81H5.52a.85.85,0,0,1-.6-1.45L9.1,3.18a.84.84,0,0,1,1.19,0h0l4.18,4.18a.85.85,0,0,1,0,1.2A.82.82,0,0,1,13.89,8.81Z", transform: "translate(-4.67 -2.93)" }),
        React.createElement("path", { d: "M5.52,11h8.36a.84.84,0,0,1,.6,1.44L10.3,16.58a.84.84,0,0,1-1.19,0h0L4.92,12.39A.85.85,0,0,1,5.52,11Z", transform: "translate(-4.67 -2.93)" })));
});
